module.exports = __webpack_public_path__ + "img/logo_and_name.d2a9c1f7.svg";